const TOKEN_KEY = "sso_token";

const authStore = {
  setToken(token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  },

  getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  removeToken() {
    sessionStorage.removeItem(TOKEN_KEY);
  },

  isAuthenticated() {
    return !!sessionStorage.getItem(TOKEN_KEY);
  },
};

export default authStore;
